<template>
    <div class="elunittree">
         <!-- 新的Element单选单位树形控件 -->
        <div style="margin-bottom: 5px;">
            <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        </div>
         	<el-scrollbar style="height:calc(100% - 55px);width: 100%;">
			    <el-tree class="filter-tree" :data="unitTree" 
                  :default-expanded-keys="defaultExpanded" 
                    :current-node-key='defaultDevice'
                    :expand-on-click-node="true" 
                    node-key="id" :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree" @node-click="nodeClick"
                  >
                  <template #default="{ node }">
                    <span class="custom-tree-node">
                          <img src="../../../../public/static/image/elTree/1.9.png"/>    
                          {{ node.label }}
                    </span>
                  </template>
                </el-tree>
		</el-scrollbar>
    </div>
</template>

<script>
export default {

    data() {
        return {
            filterText: "",
             defaultProps: {
					children: 'next',
					label: 'name',
       
			    	},
           defaultExpanded:[],
				   defaultDevice:"",
        };
    },

    mounted() {
      if(this.unitTree && this.unitTree.length !=0){
           this.$nextTick(()=>{
                  this.defaultExpanded = [this.unitTree[0].id]
                  this.defaultDevice = this.unitTree[0].id
                  //默认选中
                  this.$refs['tree'].setCurrentKey(this.defaultDevice);
                })
      }
      
    },
    watch:{
          filterText(val) {
                this.$refs.tree.filter(val);
            },
            unitTree(val){
                this.$nextTick(()=>{
                  this.defaultExpanded = [val[0].id]
                  this.defaultDevice = val[0].id
                  //默认选中
                  this.$refs['tree'].setCurrentKey(this.defaultDevice);
                })

            }
    },
    computed:{
        unitTree(){
               return [this.$store.unitStore.state.nowUnit]
            },
    },

    methods: {
        // 树形筛选
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      tree_fn(){},
      nodeClick(val){
        this.$emit('clickItem', val)
      }
    },
};
</script>

<style lang="scss" scoped>
  .elunittree {
    width: 100%;
    height: 100%;
    .custom-tree-node {
        display: flex;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    
  }
</style>